exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "textarea[data-v-6dd903e8]{padding:16px 20px;border:2px solid #e0e8f4;border-radius:6px;resize:none;color:#646464}", ""]);

